import { render } from "./natureStudyMuseum.vue?vue&type=template&id=bbd194ea&scoped=true"
import script from "./natureStudyMuseum.vue?vue&type=script&lang=js"
export * from "./natureStudyMuseum.vue?vue&type=script&lang=js"

import "./natureStudyMuseum.vue?vue&type=style&index=0&id=bbd194ea&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbd194ea"]])

export default __exports__